require('./brokerETFsProductFileView.scss');

const PropTypes = require('prop-types');
const comlexity_icon = require('assets/icons/complexity_icon.svg');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ actions
const ProductFileActions = require('actions/brokerGetProductFile.js');
const ETFsProductActions = require('actions/brokerETFsProduct.js');
const ProductPossessionsActions = require('actions/brokerProductsPossessions.js');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const PreContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');
const TabbedBox = require('components/commons/tabbedBox/tabbedBox');
const WebappRender = require('components/conditionalRender/webappRender');
const { OKLink } = require('commonsComponents/OKLink');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ components
const BrokerETFsHeader = require('components/broker/brokerProductHeaders/brokerETFsHeader/brokerETFsHeader');
const ResumeTab = require('components/broker/brokerProductFileTabs/brokerProductFileTabsETF/resumeTab');
const BrokerETFsProductFileViewDocumentation = require('./brokerETFsProductFileViewDocumentation/brokerETFsProductFileViewDocumentation');
// Comparative tab won't be part of the next release
//const ComparativeTab = require('components/broker/brokerProductFileTabs/brokerProductFileTabsETF/comparativeTab');
const ProfitabilityTab = require('components/broker/brokerProductFileTabs/brokerProductFileTabsETF/profitabilityTab/profitabilityTab');
const RatingRiskTab = require('components/broker/brokerProductFileTabs/brokerProductFileTabsETF/ratingRiskTab/ratingRiskTab');
const WalletTab = require('components/broker/brokerProductFileTabs/brokerProductFileTabsETF/walletTab');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const { PROC_BROKER_ETFS_PG_NAME } = require('utilities/tagging');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @ helpers
const i18n = require('core/i18n').i18n;
const { FormattedText } = require('core/i18n').i18n;
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @n constants
const { ETFS_DETAILS, OPENTRADER } = require('constants/flagBasedFeatures');
const { MYPROFILE_BROKER_EXPLORE_URL, BROKER_INFO_SCREEN } = require('constants/index');

class BrokerETFsProductFileView extends React.Component {
    constructor(props) {
        super(props);
        this.getProductDetails = this.getProductDetails.bind(this);
    }

    componentDidMount() {
        const { immFlagBasedFeatures } = this.props;
        this.getProductDetails();
        this.props.fetchOpenTraderLink();
        this.props.checkPersonalInformationData();
        if (immFlagBasedFeatures.get('etfs_legal_documents')) {
            this.props.getETFsDocuments(this.props.match.params.isin);
        }
        this.props.getETFsCatalogueDetails(this.props.match.params.isin);
        scrollToTop();

        const customData = {
            nombrePagina: 'broker/ficha-etf',
            productName: this.props.match.params.isin
        };
        window && window.utag && window.utag.view && window.utag.view(customData)
    }

    componentWillUnmount() {
        this.props.resetPrecontractualMail();
    }

    getProductDetails() {
        const { getETFsProduct, getProductDetails, getProductPossessions, getETFsRatingRiskTab, match: { params: { isin, iso } } } = this.props;
        getETFsProduct(isin, iso, BROKER_INFO_SCREEN);
        getProductDetails(isin, iso, BROKER_INFO_SCREEN);
        getProductPossessions(isin, iso);
        getETFsRatingRiskTab(isin);
    }

    handleOnClick = () => {
        taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'searchButtonOnProduct')
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_URL);
    }

    buildDocumentationLinkCC(link, label) {
        return link
            ? (
                <OKLink
                    onClick={() => { window.open(link, '_blank'); }}
                >
                    <FormattedText value={label} />
                </OKLink>
            ) : (
                <OKLink>
                    <FormattedText value={label} />
                </OKLink>
            );
    }

    buildDocumentationSectionCC() {
        const { etfsProduct, immProfile, match: { params: { isin } }, sendBrokerPreContractualMail } = this.props;
        const immDocumentsURL = etfsProduct.getIn(['documentsURL']);
        const clientEmail = PersonalDataHelper.getEmail(immProfile);
        const clientName = immProfile.get('nombreCliente', '');
        const dfiLink = this.buildDocumentationLinkCC(
            immDocumentsURL.get('dfi'),
            'broker-etfsProductFileViewCCDocumentationLinkDFI'
        );
        const iesLink = this.buildDocumentationLinkCC(
            immDocumentsURL.get('ies'),
            'broker-etfsProductFileViewCCDocumentationLinkLastEconomicReport'
        );
        const mcLink = this.buildDocumentationLinkCC(
            immDocumentsURL.get('mc'),
            'broker-etfsProductFileViewCCDocumentationLinkExpensesAndCosts'
        );

        const mailParams = {
            clientAlias: clientName,
            email: clientEmail,
            isin: isin,
            isinDescribe: etfsProduct.get('companyName'),
            productType: 'ETF',
            orderType: "documentos"
        };

        if (immDocumentsURL.get('mc')) {
            mailParams.marketingReport = immDocumentsURL.get('mc');
        }

        if (immDocumentsURL.get('dfi')) {
            mailParams.productKID = immDocumentsURL.get('dfi');
        }

        if (immDocumentsURL.get('ies')) {
            mailParams.economicReport = immDocumentsURL.get('ies');
        }

        return (
            <div>
                <BlockInfo>
                    <div className="broker-etfs-product-file-view__cc-documentation-content">
                        <FormattedText value="broker-etfsProductFileViewCCDocumentationContent1" />
                    </div>
                    <div>
                        <FormattedTextWithComponents
                            value="broker-etfsProductFileViewCCDocumentationContent2"
                            injectedComponents={[dfiLink, iesLink, mcLink]}
                        />
                    </div>
                </BlockInfo>
                <ContentBox customClassName="broker-etfs-product-file-view__cc-documentation-email-info">
                    <PreContractualMailInfo
                        email={clientEmail}
                        preContractualMail={this.props.immPreContractualMail}
                        sendMailParams={mailParams}
                        sendEmail={sendBrokerPreContractualMail}
                        showLegalText={false}
                        legalInfoText={false}
                    />
                </ContentBox>
            </div>
        );
    }

    getProductDocumentation() {
        const { etfsProduct } = this.props;
        let arrayDocuments;
        const immDocumentsURL = etfsProduct.getIn(['documentsURL']);
        if (immDocumentsURL) {
            arrayDocuments = [
                {
                    titlePDF: 'broker-etfsProductFileViewDocumentationButtonDFI',
                    link: immDocumentsURL.get('dfi'),
                    fireTagging: () => taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'documentation', 'DFI')
                },
                {
                    titlePDF: 'broker-etfsProductFileViewDocumentationButtonLastEconomicReport',
                    link: immDocumentsURL.get('ies'),
                    fireTagging: () => taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'documentation', 'last report')

                },
                {
                    titlePDF: 'broker-etfsProductFileViewDocumentationButtonMC',
                    link: immDocumentsURL.get('mc'),
                    fireTagging: () => taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'documentation', 'information')
                },
            ];
        }
        return arrayDocuments
    }


    buildDocumentationSection() {
        const productDocumentation = this.getProductDocumentation();
        return <BrokerETFsProductFileViewDocumentation product={productDocumentation} />
    }

    render() {
        const {
            productFile,
            immFlagBasedFeatures,
            immMyInvestments,
            immOpenTrader,
            etfsProduct,
            match: { params },
            getETFsProductByIsin
        } = this.props;
        const handleProductUpdate = this.getProductDetails;
        const etfsProductSubtitle = etfsProduct.get("isCryptoETF")
            ? i18n.formatText("broker-etfsCriptoSummaryProductName")
            : i18n.formatText("broker-etfsProductFileViewSubtitle");
        const resumeLabel = i18n.formatText('broker-etfsProductFileViewResumeLabel');
        // Comparative tab won't be part of the next release
        //const comparativeLabel = i18n.formatText('broker-etfsProductFileViewComparativeLabel');
        const profitabilityLabel = i18n.formatText('broker-etfsProductFileViewProfitabilityLabel');
        const ratingRiskLabel = i18n.formatText('broker-etfsProductFileViewRatingRiskLabel');
        const walletLabel = i18n.formatText('broker-etfsProductFileViewWalletLabel');
        const isComplex = etfsProduct.get('complexity')

        const mappingBreadcrumb = [
            {
                text: i18n.formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: i18n.formatText('breadcrumb-brokerAdvancedSearch'),
                url: `/myprofile/broker/explore`
            },
            {
                text: productFile.get('companyName'),
                url: ''
            }
        ];

        const tabs = [
            {
                label: <span onClick={() => taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'tabs', 'resume')}>{resumeLabel}</span>,
                content: <ResumeTab etfsProduct={etfsProduct} retryRequest={getETFsProductByIsin} />
            },
            // Comparative tab won't be part of the next release
            /*{
                label: comparativeLabel,
                content: <ComparativeTab />
            },*/
            {
                label: <span onClick={() => taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'tabs', 'profitability')}>{profitabilityLabel}</span>,
                content: <ProfitabilityTab product={etfsProduct} />
            },
            {
                label: <span onClick={() => taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'tabs', 'rating and risk')}>{ratingRiskLabel}</span>,
                content: <RatingRiskTab product={etfsProduct} />
            },
            {
                label: <span onClick={() => taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'tabs', 'portfolio')}>{walletLabel}</span>,
                content: <WalletTab etfsProduct={etfsProduct} />
            }
        ];

        let productFileContent;

        if (!productFile.get('error')) {
            productFileContent = (
                <ContentBox customClassName="broker-product-file-body">
                    <TabbedBox
                        onlyTabs={true}
                        onlyContent={true}
                        id="brokerEtfsProductTabs"
                        tabs={tabs}
                        customClassName="broker-product-file-view__content"
                    />
                </ContentBox>
            );
        }
        let documentationSection;
        if (
            immFlagBasedFeatures.get('etfs_legal_documents') &&
            !etfsProduct.get('isFetchingETFDocuments') &&
            !etfsProduct.get('fetchingETFDocumentsFailed')
        ) {
            documentationSection = !__CONTACT_CENTER__ ? this.buildDocumentationSection() : this.buildDocumentationSectionCC();
        }

        return (
            <div className="broker-etfs-product-file-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="broker" customClass="col-xs-12">
                            <BrokerTruncatedBreadcrumb
                                titleKey="broker-productFileTitle"
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={etfsProductSubtitle}
                            >
                                <OKButton inverse={true} modifier="ghost" onClick={() => this.handleOnClick()}>
                                    <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                                </OKButton>
                                <WebappRender>
                                    <FeatureTogglingRender notAllowedProductKey={[ETFS_DETAILS, OPENTRADER]} productKeyFilter="every" >
                                        <OKButton onClick={() => taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'openTraderButton')} inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                            <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                        </OKButton>
                                    </FeatureTogglingRender>
                                </WebappRender>
                            </BrokerTruncatedBreadcrumb>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        {
                            isComplex && (
                                <div className="broker-etfs-product-file-view__etfs-risk-indicator">
                                    <FormattedText value="fundsCard-alertComplexity_title" /><br />
                                    <img src={comlexity_icon} alt="complexity icon" /> <FormattedText value="fundsCard-alertComplexity_content" />
                                </div>
                            )
                        }
                        <div className="row grid-view--content-position-negative broker-etfs-product-file-view--content-position-etfs">
                            <div className="col-xs-12">
                                <BrokerETFsHeader
                                    productFile={productFile}
                                    etfsProduct={etfsProduct}
                                    immMyInvestments={immMyInvestments}
                                    handleUpdate={handleProductUpdate}
                                    isin={params.isin}
                                    iso={params.iso}
                                    fireTaggingBuyButton={(isin) => taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'buttonBuy', isin)}
                                    immFlagBasedFeatures={immFlagBasedFeatures}
                                />
                                {productFileContent}
                                {documentationSection}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerETFsProductFileView.propTypes = {
    getETFsDocuments: PropTypes.func,
    getProductDetails: PropTypes.func,
    getProductPossessions: PropTypes.func,
    getETFsProduct: PropTypes.func,
    getETFsRatingRiskTab: PropTypes.func,
    getETFsCatalogueDetails: PropTypes.func,
    match: PropTypes.object,
    productFile: PropTypes.object,
    history: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immOpenTrader: PropTypes.object.isRequired,
    etfsProduct: PropTypes.object,
    getETFsProductByIsin: PropTypes.func.isRequired,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    checkPersonalInformationData: PropTypes.func,
    sendBrokerPreContractualMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
};

module.exports.constructor = BrokerETFsProductFileView;
module.exports.BrokerETFsProductFileView = connect(
    state => ({
        productFile: state.brokerProductFile,
        immMyInvestments: state.brokerMyInvestments,
        immOpenTrader: state.brokerOpenTrader,
        etfsProduct: state.brokerETFsProduct,
        productRiskRating: state.productRiskRating,
        immProfile: state.profile,
        immPreContractualMail: state.preContractualMail,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        getETFsDocuments: ETFsProductActions.getETFsDocuments,
        getETFsCatalogueDetails: ETFsProductActions.getETFsCatalogueDetails,
        getProductDetails: ProductFileActions.getProductFile,
        getETFsProduct: ETFsProductActions.getETFsProduct,
        getProductPossessions: ProductPossessionsActions.getProductPossessions,
        getETFsRatingRiskTab: ETFsProductActions.getETFsRatingRiskTab,
        getETFsProductByIsin: ETFsProductActions.getETFsProductByIsin,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData,
        sendBrokerPreContractualMail: PreContractualMailActions.sendBrokerPreContractualMail,
        resetPrecontractualMail: PreContractualMailActions.resetPrecontractualMail,
    }
)(withRouter(BrokerETFsProductFileView));
